import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockTakeReportData} from "./stock-take-report.data";

@Injectable()
export class StockTakeReportModel extends ReportModel<StockTakeReportData> {
    constructor(injector: Injector) {
        super(injector, StockTakeReportData);
    }
}
